import { action, computed, observable } from "mobx";
import Immersive3dTourProjectPanorama from "~/models/Immersive3dTour/Immersive3dTourProject/Immersive3dTourProjectPanorama";

class Immersive3dTourProject {
  /**
   * @property {number|null}
   */
  @observable projectId = null;

  /**
   * @property {Array}
   */
  @observable panos = [];

  /**
   * @property {Object}
   */
  @observable floors = {};

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action
  setData({ _projectId = null, _panos = [], _floors = [] }) {
    this.projectId = _projectId;
    this.floors = _floors;

    this.panos = [];

    _panos.forEach(_panorama => {
      const panorama = new Immersive3dTourProjectPanorama(_panorama);

      this.panos.push(panorama);
    });
  }

  @computed
  get panoramasByFloors() {
    const panoramasByFloors = [];
    const index = {};
    let count = 0;

    Object.keys(this.floors).forEach(floorId => {
      panoramasByFloors.push({
        id: floorId,
        name: this.floors[floorId].name,
        panoramas: [],
      });

      index[floorId] = count;
      count += 1;
    });

    this.panos.forEach(panorama => {
      panoramasByFloors[index[panorama.floor]].panoramas.push(panorama);
    });

    return panoramasByFloors;
  }
}

export default Immersive3dTourProject;
